import { timeFormat } from 'd3-time-format';

const dayLevelDataFormat = timeFormat('%Y-%m-%d');
const hourLevelDateFormat = timeFormat('%Y-%m-%d %H:%M');

export { dayLevelDataFormat, hourLevelDateFormat };
